import { WSForm, WSInputDate } from "@wingspanhq/fe-component-library";
import React from "react";
import { IDynamicFieldProps } from "../../types";
import { fieldLabel, isFieldRequired } from "../../utils/fieldRules";

export const DynamicFieldDate: React.FC<IDynamicFieldProps> = ({
  field,
  name,
  disabled,
  defaultValue
}) => (
  <WSForm.Field
    name={name}
    defaultValue={defaultValue}
    label={fieldLabel(field)}
    description={field.description ?? field.ui?.helpText}
    component={WSInputDate}
    componentProps={{
      disabled,
      required: isFieldRequired(field),
      // Date format/placeholder stay on the library defaults (mm/dd/yy) — the
      // app renders dates in the component library's formats only.
      placeholder: field.ui?.placeholder
    }}
  />
);
